import { useState, useEffect } from "react";
import { apiRequest } from "../apiRequest";

export const useV4ReportsData = (recordID) => {
  const [data, setData] = useState();

  const getRecord = async function () {
    const record = await apiRequest(`/reports/v4/${recordID}`, "GET", null);
    return record;
  };

  useEffect(() => {
    getRecord().then((response) => setData(response));

    return;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordID]);

  return data;
};
